import "./App.css";
import Layout from "./Layout/Layout";
import Home from "./Pages/Home/Home";
import { ToastContainer } from "react-bootstrap";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Privacy from "./Pages/Privacy/Privacy";
import Tnc from "./Pages/Tnc/Tnc";
import { useState } from "react";

function App() {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const props = {show, handleShow, handleClose}

  return (
    <BrowserRouter>
      <ToastContainer />
      <Layout {...props}>
        <Routes>
          <Route path="/" element={<Home {...props}  />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/tnc" element={<Tnc />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
